module.exports = __webpack_public_path__ + "static/media/friends.4aef9132.jpg";